import { styled } from "@linaria/react";
import React from "react";
import { color, fonts } from "..";

interface P {
  headerLeft: React.ReactNode;
  headerRight: React.ReactNode;
  pagination?: React.ReactNode;
  children: React.ReactNode;
  title: React.ReactNode;
  className?: string;
}

export const Header = styled.div`
  background: ${color.titanium50};
  padding: 16px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  row-gap: 16px;

  :first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
  }
`;

const HeaderLeft = styled.div`
  :not(:empty) {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 16px;
    row-gap: 8px;
  }
`;

export const HeaderRight = styled.div`
  :not(:empty) {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 16px;
  }
`;

const Pagination = styled.div`
  padding: 16px;
  display: flex;
  height: 70px;
  justify-content: space-between;
  align-items: center;
  font: ${fonts.body2};
  margin-top: auto;

  :last-child {
    border-bottom-left-radius: inherit;
    border-bottom-right-radius: inherit;
  }
`;

const Title = styled.div`
  font: ${fonts.h4};
  color: ${color.carbon900};
`;

const TableCard = ({ children, headerLeft, headerRight, title, pagination, className }: P) => (
  <div className={className}>
    {headerLeft || headerRight || title ? (
      <Header>
        {title || headerLeft ? (
          <HeaderLeft>
            {title ? <Title>{title}</Title> : null}
            {headerLeft}
          </HeaderLeft>
        ) : null}
        {headerRight ? <HeaderRight>{headerRight}</HeaderRight> : null}
      </Header>
    ) : null}
    {children}
    {pagination ? <Pagination>{pagination}</Pagination> : null}
  </div>
);

export default TableCard;
